import { BrowserRouter, Switch, Route } from 'react-router-dom'

import Navbar from './components/Navbar'
import ThemeSelector from './components/ThemeSelector'
import { useTheme } from './hooks/useTheme'

// page components
import Home from './pages/home/Home'
import Lessons from './pages/lessons/Lessons'
import Journal from './pages/journal/Journal'
import Post from './pages/post/Post'
import Portfolio from './pages/portfolio/Portfolio'
import Footer from './components/Footer'
import Contact from './pages/contact/Contact'
import Games from './pages/games/Games'
import MemoryGame from './pages/memory/MemoryGame'
import BinaryBreakout from './pages/scratch/BinaryBreakout'
import Psychward from './pages/psychward/Psychward'
import Plan from './pages/plan/Plan'
import Project from './pages/project/Project'


// styles
import './App.css'

function App() {
  const { mode } = useTheme()

  return (
    <div className={`App ${mode}`}>
      <BrowserRouter>
        <Navbar />
        <ThemeSelector />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route  path="/lessons">
            <Lessons />
          </Route>
          <Route  path="/journal">
            <Journal />
          </Route>
          <Route  path="/portfolio">
            <Portfolio />
          </Route>
          <Route  path="/games">
            <Games />
          </Route>
          <Route  path="/contact">
            <Contact />
          </Route>
          <Route path="/journals/:id">
            <Post />
          </Route>
          <Route path="/lesson-plan/:id">
            <Plan />
          </Route>
          <Route path="/projects/:id">
            <Project />
          </Route>
          <Route path="/memory-game">
            <MemoryGame />
          </Route>
          <Route path="/binary-breakout">
            <BinaryBreakout />
          </Route>
          <Route path="/psychward">
            <Psychward />
          </Route>
        </Switch>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App
